module.exports = __webpack_public_path__ + "static/media/cardnum.4f739fb2.svg";